<template>
    <div class="app flex-row align-items-center">
        <vue-progress-bar></vue-progress-bar>
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <b-form class="container" v-on:keydown.enter="submit">
                                    <b-form-group>
                                        <h1>{{ $t('otp.otp_title') }}</h1>
                                        <div class="clearfix"></div><br/>
                                        <span class="text-muted">{{ $t('otp.otp_description') }}</span>
                                        <b-input-group class="mb-2 mt-2">
                                          <input type="text" style="display: none" v-model="$v.form.otp.$model" >
<!--                                            <b-form-input type="text" v-model.strim="$v.form.otp.$model" class="form-control" v-on:keypress.enter="submit"-->
<!--                                                          :state="!$v.form.otp.$invalid"-->
<!--                                                          aria-describedby="otp-feedback"/>-->
                                          <input type="text" :state="!$v.form.otp.$invalid" aria-invalid="true" id="otp-feedback" v-model.strim="$v.form.otp.$model" v-on:keypress.enter="submit" class="form-control form-control is-invalid" aria-describedby="otp-feedback">
                                          <b-form-invalid-feedback id="otp-feedback">
                                                <div v-if="!$v.form.otp.required">{{ $t('otp.required_otp_filed') }}</div>
                                                <div v-else-if="!$v.form.otp.numeric">OTP must be number.</div>
                                            </b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-row>
                                        <b-col cols="5">
                                            <b-button v-on:click="submit" variant="dark" class="px-4" id="btn-login"
                                                      :disabled="$v.form.$invalid">
                                                {{ $t('otp.otp_title') }}
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
      <snowCss v-if="isDisplayChristmasTheme"></snowCss>
    </div>
</template>

<style scoped>
    .login-language {
        width: 100px;
        float: right;
        margin-top: -10px;
    }

    .login-card-body {
        padding-top: 0px !important;
        margin-top: -20px !important;
    }

    .login-logo {
        width: 85%;
        margin-bottom: 20px;
    }

    .login-copyright {
        margin-top: 40px;
        margin-bottom: -30px;
    }
</style>

<script>
    import ChangeLanguage from '../../components/Partials/ChangeLanguages.vue'
    import {validationMixin} from 'vuelidate'
    import {required,numeric} from 'vuelidate/lib/validators'
    import snowCss from '../../components/ChristmasThemeCSS'

    export default {
        name: 'CheckOtp',
        components: {
            ChangeLanguage,
            snowCss
        },
        data() {
            return {
                form: {
                    uuid:this.$route.params.uuid,
                    otp:''
                },
                isDisplayChristmasTheme : false
            }
        },
        mixins: [
            validationMixin
        ],
        validations: {
            form: {
                otp: {
                    required,
                    numeric
                }
            }
        },
        methods: {
            submit: function () {
                if (!this.$v.$invalid) {
                  this.$Progress.start()
                  this.$auth.login({
                    headers: {
                      'Accept': 'application/json'
                    },
                    data: this.form,
                    redirect: '/home',
                    success: (response) => {
                      this.axios.tenant.getClientDetail(localStorage.getItem('clientID'), (response) => {
                        this.$store.commit('setConfig', {
                          base: {
                            id: response.data.data.item.id
                          },
                          country_code: response.data.data.item.country,
                          main: response.data.data.item.main_config,
                          manual_config: response.data.data.item.manual_config,
                          gms: response.data.data.item.gms_config
                        })
                        this.$session.set('config', {
                          base: {
                            id: response.data.data.item.id
                          },
                          country_code: response.data.data.item.country,
                          main: response.data.data.item.main_config,
                          manual_config: response.data.data.item.manual_config,
                          gms: response.data.data.item.gms_config
                        })
                        let lang = 'en'
                        if (response.data.data.item != null && response.data.data.item.main_config != null && response.data.data.item.main_config.language != null) {
                          lang = response.data.data.item.main_config.language[0]
                        }
                        let isUseChristmasTheme = response.data.data.item.main_config.christmas_theme
                        if(isUseChristmasTheme) {
                          this.$session.set('theme',true)
                          this.$session.set('show_config_christmas',true)
                          this.isDisplayChristmasTheme = true
                        }
                        this.$store.dispatch('setLang', lang)
                        this.$root.$emit('activeTheme')
                        this.$session.set('lang', lang)
                        Vue.axios.defaults.headers.common['Lang'] = lang
                        this.$store.commit('setLang', lang)
                        this.$root.$emit('changeLang')
                        this.$root.$emit('UpdatedConfig')
                      }, error => {
                        console.log(error)
                      })
                      this.$Progress.finish()
                    },
                    error: function (error) {
                      this.$Progress.fail()
                    }
                  })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/admin/CheckOtp.vue